import { mapState } from 'vuex';
import { isNullOrEmpty } from '@/utils/vuex';
export default {
  name: 'CoreDtwinStateBridgeMqttNg',
  props: {
    lclModel: {
      type: Object,
      required: true
    },
    bridgeConfig: {
      type: Object,
      required: false,
      default: () => ({})
    },
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      deviceIdentifier: null,
      parsedPacketVariable: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme']),
    targetFormat() {
      var _this$bridgeConfig, _this$bridgeConfig2;
      const bridgeTarget = ((_this$bridgeConfig = this.bridgeConfig) === null || _this$bridgeConfig === void 0 || (_this$bridgeConfig = _this$bridgeConfig.config) === null || _this$bridgeConfig === void 0 ? void 0 : _this$bridgeConfig.targetFormat) || ((_this$bridgeConfig2 = this.bridgeConfig) === null || _this$bridgeConfig2 === void 0 ? void 0 : _this$bridgeConfig2.targetFormat);
      return bridgeTarget === 'direct' ? 'direct' : 'ddr';
    },
    formIsValid() {
      if (this.templateContext || this.targetFormat === 'ddr') {
        return true;
      }
      return !isNullOrEmpty(this.deviceIdentifier);
    }
  },
  watch: {
    parsedPacketVariable() {
      this.emitSelection();
    },
    deviceIdentifier() {
      this.emitSelection();
    }
  },
  created() {
    var _this$lclModel;
    const bindingOptions = (_this$lclModel = this.lclModel) === null || _this$lclModel === void 0 || (_this$lclModel = _this$lclModel.properties) === null || _this$lclModel === void 0 || (_this$lclModel = _this$lclModel.binding) === null || _this$lclModel === void 0 ? void 0 : _this$lclModel.options;
    if (this.mode !== 'create' && this.mode !== 'import') {
      this.deviceIdentifier = (bindingOptions === null || bindingOptions === void 0 ? void 0 : bindingOptions.identifier) || null;
      this.parsedPacketVariable = (bindingOptions === null || bindingOptions === void 0 ? void 0 : bindingOptions.variable) || null;
    }
  },
  methods: {
    emitSelection() {
      this.$emit('bridge-binding-changed', {
        variable: this.parsedPacketVariable
      });
    },
    saveState() {
      var _this$lclModel2;
      if (!((_this$lclModel2 = this.lclModel) !== null && _this$lclModel2 !== void 0 && (_this$lclModel2 = _this$lclModel2.properties) !== null && _this$lclModel2 !== void 0 && (_this$lclModel2 = _this$lclModel2.binding) !== null && _this$lclModel2 !== void 0 && _this$lclModel2.options)) {
        return;
      }
      this.lclModel.properties.binding.options.identifier = this.deviceIdentifier;
      this.lclModel.properties.binding.options.variable = this.parsedPacketVariable;
    }
  }
};